import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import DatePicker from "vue2-datepicker";
import { IOtherAppointmentSlot } from "@/models";
import moment from "moment";

@Component({
    name: "otherappointment-edit",
    components: {
        datepicker: DatePicker,
    },
})

export default class OtherAppointmentEdit extends Vue {
    public internalSelectedMeeting: IOtherAppointmentSlot;

    public editMeetingModal: string = "editMeetingModal";

    public constructor() {
        super();

        this.internalSelectedMeeting = this.selectedMeeting;
    }

    public get selectedMeeting(): IOtherAppointmentSlot {
        return this.$store.getters["otherAppointments/getSelectedOtherAppointment"]();
    }

    public get notBefore(): Date {
        return moment().hours(0).minutes(0).toDate();
    }

    public mounted(): void {

        this.internalSelectedMeeting = { ...this.selectedMeeting };
        this.internalSelectedMeeting.otherAppointment = { ...this.selectedMeeting.otherAppointment };
        this.$modal.show(this.editMeetingModal);
    }

    public deleteMeeting(): void {
        this.$store.dispatch("otherAppointments/deleteOtherAppointment", this.internalSelectedMeeting.otherAppointment).then(() => {
            this.$modal.hide(this.editMeetingModal);
        });
    }

    public editMeeting(): void {
        this.$store.dispatch("otherAppointments/editOtherAppointment", this.internalSelectedMeeting.otherAppointment).then(() => {
            this.$modal.hide(this.editMeetingModal);
        });
    }

    public emitChange(): void {
        this.$emit("change");
    }
}
